import { csv } from "d3-fetch";
import _ from "lodash";
import DEATH_DELAYS from "../data/death_delays.csv";
import TILEGRID from "../data/tilegrid_usa_nyt.json";

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([csv(DEATH_DELAYS)]).then(([deathDelays]) => {
    const data = {};

    const merged = _.merge(
      _.keyBy(TILEGRID, "key"),
      _.keyBy(deathDelays, "abbrv")
    );
    const values = _.values(merged);
    const cleanValues = values.map((item) => {
      const { state, abbrv, percentage, ...rest } = item;
      return {
        ...rest,
        percentage: +percentage,
      };
    });
    data.stateData = cleanValues;
    return data;
  });
};

export default loadData;
